<template>
	<v-row v-if="!$store.getters.progress" class="ma-0">
		<v-col class="pa-0">
            <v-tabs
                class=" pb-2"
                :height="34"
                background-color="background-1"
                slider-color="primary">
				<v-tab :key="1" ripple>Evasione Ordine</v-tab>

                <v-tab-item :key="1" class="pb-offset background-1">
					<show
						:id="id"
						:models="models"
						:infos="infos"
						topClass="pt-2"
					></show>

					<create
						v-if="loadCreate"
						:model.sync="purchaseddt"
						modelDef="purchaseddts"
						ref="createpurchaseddt"
						:default-input="defaultInput"
						:show-save="false"
						:show-relations="false"
						row-class="mx-0 pt-0"
					></create>

					<v-col class="pa-0 pt-4" v-if="relations.products">
						<v-card class="flex pa-0 background-2 round-card">
                			<v-card-title class="pa-3">
				    			<p class="pl-2 pl-xl-3">Evasione Prodotti</p>
								<v-spacer></v-spacer>
								<v-text-field class="hidden-xs-only font-weight-regular mr-4"
									append-icon="mdi-magnify"
									label="Cerca"
									v-model="search"
									clearable
									hide-details
									outlined
									dense
								></v-text-field>
								<v-switch
									inset
									style="padding-top: 0; margin: auto; margin-right: 16px"
									label="Nascondi completati"
									v-model="filterSet['hide_product_purchaseorder_completed']"
									hide-details
									color="primary"
								></v-switch>
								<v-switch
									inset
									style="padding-top: 0; margin: auto"
									label="Evadi tutto"
									v-model="processAll"
									hide-details
									color="primary"
								></v-switch>
                			</v-card-title>        
							<v-divider></v-divider>
							<v-container class="pa-0" fluid>			  
								<v-row class="pt-0">
									<v-col cols="12" class="pt-0">
										<v-card class="flex background-2" elevation="0">
											<v-data-table
												class="background-2 no-max-height"
												:headers="relations.products.info.fieldDefs"
												:items="filteredItems"
												:search="search"
												hide-default-footer
												disable-pagination
												item-key="id"
												show-expand>
												<template v-slot:item="{item, expand, isExpanded, headers, index}">
													<tr>
														<template v-for="(header, h) in headers">
															<td v-if="header.value == 'data-table-expand'" :key="'expand-'+h">
																<v-btn
																	v-if="item.description"
																	icon
																	small
																	@click.stop="expand(!isExpanded)">
																	<v-icon :size="24" color="info">mdi-file-document</v-icon>
																</v-btn>
															</td>
															<td v-else-if="header.value === 'number'" :key="h"
															:class="['column sortable text-xs-'+(header.align?header.align:'left')]"
															>
																{{ index +1 }}
															</td>
															<td v-else-if="header.value == 'price'" :key="h"
															:class="['column sortable text-xs-'+(header.align?header.align:'left')]"
															>
																{{ $eventBusUtility.headerValue(header.value, item) | currency }}
															</td>
															<td v-else-if="header.value === 'quantity'" :key="'quantity-'+h">
																<v-chip small color="grey darken-1" dark>
																	<v-icon small left>mdi-package-variant</v-icon>
																	{{ item.quantity }}
																</v-chip>
															</td>
															<td v-else-if="header.value === 'dispatched_quantity'" :key="'dispatched-'+h">
																<v-chip
																	small
																	:color="item.dispatched_quantity > 0 ? 'success' : 'grey lighten-1'"
																	:dark="item.dispatched_quantity > 0">
																	<v-icon small left>mdi-check-circle</v-icon>
																	{{ item.dispatched_quantity }}
																</v-chip>
															</td>
															<td v-else-if="header.type == 'date'" :key="h" :class="'text-xs-'+header.align"
															>
																{{ item[header.value] | date }}
															</td>
															<td v-else-if="header.type == 'chips'" :class="'text-xs-'+header.align" :key="h">
																<v-chip v-for="(chip, c) in item[header.value]" small :key="c">{{ chip }}</v-chip>
															</td>
															<td v-else-if="header.value == 'quantity_to_process'" :key="h"
																:class="['column sortable text-xs-'+(header.align?header.align:'left')]"
																width="200px"
																style="padding-right: 24px !important;">
																<template v-if="item.type === 'description'">
																	<v-switch color="primary" inset hide-details v-model="item.selected_description"></v-switch>
																</template>
																<v-text-field v-else
																	v-model.number="item.quantity_to_process"
																	class="conversion-quantity"
																	label="Quantità"
																	type="number"
																	min="0"
																	hide-details
																	:error-messages="errors.collect('Quantità_'+index)"
																	v-validate="'required|min_value:0|max_value:'+getMaxDispatchable(item)"
																	:data-vv-name="'Quantità_'+index"
																	data-vv-as="Quantità"
																	dense
																	outlined
																></v-text-field>
															</td>
															<td v-else-if="header.value === 'selected_lot_allocations'" :key="'lots-'+h">
																<conversion-lots-cell :item="item" quantity-key="quantity_to_process" :document-parent="purchaseddt"></conversion-lots-cell>
															</td>
															<td v-else :class="'text-xs-'+header.align" :key="h">
																{{ $eventBusUtility.headerValue(header.value, item) }}
															</td>
														</template>
													</tr>
												</template>
												<template v-slot:expanded-item="{ item, headers }">
													<tr v-if="item.description">
														<td :colspan="headers.length" class="pa-0">
															<v-card class="elevation-0">
																<v-card-text pa-4 v-html="item.description"></v-card-text>
															</v-card>
														</td>
													</tr>
												</template>
											</v-data-table>
										<v-divider></v-divider>
										</v-card>
									</v-col>
								</v-row>

							</v-container>
						</v-card>
					</v-col>
					<v-tooltip top>
						<template v-slot:activator="{ on: tooltip }">
							<v-fab-transition slot="activator">
								<v-btn
									v-on="{ ...tooltip }"
									@click.native="confirmProcess = true"
									:loading="saved"
									color="primary"
									dark
									fixed
									bottom
									right
									fab>
									<v-icon>input</v-icon>
								</v-btn>
							</v-fab-transition>
						</template>
						<span>Evadi quantità</span>
					</v-tooltip>

					<confirm-dialog
						:confirmModel="confirmProcess"
						mainTitle="Vuoi evadere le quantità da te selezionate?"
						secondTitle="Sarà creato un DDT di Acquisto con le quantità dei prodotti da te scelte"
						@update:confirmModel="confirmProcess = false"
						:atConfirm="processOrder"
						:confirm="{color: 'info', label: 'crea'}"
					></confirm-dialog>
                </v-tab-item>
            </v-tabs>
		</v-col>
	</v-row>
</template>

<script>

	import Vue from 'vue'
	import Create from '@/components/common/Create'
	import ConversionLotsCell from '@/components/common/ConversionLotsCell'
	import { missingSerials, conversionPayloadRows } from '@/components/common/conversionLots'

	export default {
		name: 'purchaseorder-process',
		components: {
			Create,
			ConversionLotsCell
		},
		props: {
			id: {
				type: Number,
				default: 0
			},
			selected: Array,
		},
		
		data() {
			return {
				ids: [],
				search: '',
				modelDef: 'purchaseorders',
                models: {},
				infos: {},
				relations: {},
				purchaseddt: {},
				saved: false,
				footerClass: [],
				dialog: false,
				processAll: false,
				confirmProcess: false,
				filterSet: {'hide_product_purchaseorder_completed': true},
				defaultInput: {},
				loadCreate: false
			}
		},

		watch: {
			processAll: {
				handler(newValue, oldValue) {
					_.forEach(this.relations.products.collection, (product) => {
						if(newValue) {
							Vue.set(product, 'quantity_to_process', product.quantity - product.dispatched_quantity)
						} else {
							Vue.set(product, 'quantity_to_process', 0)
						}
					})
				}
			}
		},

		created() {
			var url = 'purchaseorders-info-process/'
			var data = {}

			if(this.selected && this.selected.length > 0) {
				_.forEach(this.selected, (value, key) => {
					this.ids[key] = value.id
				})
				data = {
					ids: this.ids
				}
			} else if(! Number.isNaN(this.id)) {
				url += this.id
				this.ids = [this.id]
			}

			this.axios.post(url, data).then(response => {
				// get body data
				this.models = response.data.models
				this.infos = response.data.infos
				this.relations = response.data.relations

				let defaultInputData = {company_id: this.models.supplier.id}
				if (response.data.project_id) {
					defaultInputData.project_id = response.data.project_id
				}
				if (response.data.currency != null) {
					defaultInputData.currency = response.data.currency
				}
				if (response.data.exchange_rate != null) {
					defaultInputData.exchange_rate = response.data.exchange_rate
				}
				if (response.data.exchange_rate_date != null) {
					defaultInputData.exchange_rate_date = response.data.exchange_rate_date
				}
				// sconto globale comune agli ordini selezionati: visibile e modificabile nel form
				if (response.data.global_discount != null) {
					defaultInputData.global_discount = response.data.global_discount
				}
				this.$set(this, 'defaultInput', defaultInputData)
				this.loadCreate = true

				_.forEach(this.relations.products.collection, (product) => {
					Vue.set(product, 'quantity_to_process', 0)
				})
				this.$store.commit('endProgress') 

			}, response => {
				this.$store.commit('endProgress')
				this.$router.back()
			})

		},

		computed: {
            filteredItems() {

                let filtered = this.relations.products.collection.filter((item) => {
                    if(this.filterSet.hide_product_purchaseorder_completed) {
						return item.dispatched_quantity < item.quantity
					}
				})
				
                return filtered.length > 0 ? filtered : this.relations.products.collection
            }
		},

		methods: {

			roundNumber(num) {
				return Math.round(num * 100 + Number.EPSILON) / 100
			},

			getMaxDispatchable(item) {
				return this.roundNumber(item.quantity - item.dispatched_quantity)
			},

			processOrder() {
				this.$validator.validateAll().then(result => {
					if (!result) {
						this.$store.commit('setSnackbar', {
							timeout: 6000,
							text: 'Controlla tutti i campi.',
							value: true,
							color: 'error'
						})
						return false
					}
					const missing = missingSerials(this.relations.products.collection, 'quantity_to_process')
					if (missing.length) {
						this.$store.commit('setSnackbar', {
							timeout: 8000,
							text: 'Indica le matricole di: ' + missing.join(', '),
							value: true,
							color: 'error'
						})
						return false
					}
					this.$refs.createpurchaseddt.$refs.fieldsgenerator.$validator.validateAll().then(result => {
						if (!result) {
							this.$store.commit('setSnackbar', {
								timeout: 6000,
								text: 'Controlla tutti i campi.',
								value: true,
								color: 'error'
							})
							return false
						}

						this.saved = true
						this.axios.post('purchaseorders-process/', {ids: this.ids, 'products': conversionPayloadRows(this.relations.products.collection), purchaseddt: this.purchaseddt}).then(response => {
							this.saved = false

							// get body data
							this.$router.push({ name: 'purchaseddts-show', params: { id: parseInt(response.data.id) }})

						}, response => {
							// error callback
							this.saved = false
						})
					}).catch(() => {

					})
				}).catch(() => {

				})
			},

		},
	}
</script>

<style>
	.no-max-height .v-data-table__wrapper {
		max-height: none !important;
	}
</style>